import script from "./FFSCoveredPatientsList.vue?vue&type=script&setup=true&lang=js"
export * from "./FFSCoveredPatientsList.vue?vue&type=script&setup=true&lang=js"

import "./FFSCoveredPatientsList.vue?vue&type=style&index=0&id=7a8a8619&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8a8619"]])

export default __exports__